<template>
    <div class="public-layout">
      <router-view />
    </div>
  </template>
  
  <script>
  export default {
    name: 'PublicLayout',
  };
  </script>
  
  <style scoped>
  .public-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f8f9fa;
  }
  </style>
  